import { TrackingService } from '../tracking-consent/tracking.service';
import * as i0 from "@angular/core";
import * as i1 from "../tracking-consent/tracking.service";
export let TrackingConsentDirective = /*#__PURE__*/(() => {
  class TrackingConsentDirective {
    constructor(service) {
      this.service = service;
    }
    onClick() {
      this.service.unsetConsentPreference();
    }
    static {
      this.ɵfac = function TrackingConsentDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackingConsentDirective)(i0.ɵɵdirectiveInject(i1.TrackingService));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: TrackingConsentDirective,
        selectors: [["", "trackingChangeConsent", ""]],
        hostBindings: function TrackingConsentDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function TrackingConsentDirective_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        }
      });
    }
  }
  return TrackingConsentDirective;
})();